import React from "react";

import "../../theme/styles.css";
import { withStyles } from "@material-ui/core/styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NavBar from "../../components/NavBar";
import Header from "../../components/Header";
import AppStoreLink from "../../components/AppStoreLink";
import Footer from "../../components/Footer";
import Images from "../../theme/Images";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  textField: {
    flex: 1,
    marginTop: theme.spacing.unit,
    marginBottom: 0
  },
  button: {
    marginTop: theme.spacing.unit * 2
  }
});

const HomeScreen = () => {
  return (
    <div id="homePage">
      <NavBar />

      <Header
        title="Mobile Car Wash App"
        subtitle="We send professional Washers & Detailers direct to your location"
      />

      <article>
        <h1>Starting at $40!</h1>
        <section>
          <img src={Images.icon_work} alt="Work for yourself" />
          <div>
            <h2>Save time &amp; energy</h2>
            <p>
              Nobody enjoys giving up their free time waiting around at the
              local car wash.
            </p>
            <p>Install Mucky Duck and the wash comes to you!</p>
          </div>
        </section>
        <section>
          <img src={Images.icon_work} alt="Work for yourself" />
          <div>
            <h2>Easy &amp; friendly</h2>
            <p>
              Mucky Duck vets and provides orientation to all the professional
              detailers in our system. You can be sure of a simple, friendly and
              easy process with no upsell.
            </p>
          </div>
        </section>
        <section>
          <img src={Images.icon_work} alt="Work for yourself" />
          <div>
            <h2>Safe &amp; secure</h2>
            <p>
              Mucky Duck securely processes your payment and ensures you only
              pay for a wash after it has completed.
            </p>
            <p>
              We partner with
              {" "}
              <a href="https;//stripe.com/" target="_blank">
                Stripe
              </a>
              {" "}
              for payment processing so your information always stays safe &amp;
              secure.
            </p>
          </div>
        </section>
        <section>
          <img src={Images.icon_work} alt="Work for yourself" />
          <div>
            <h2>Convenient</h2>
            <p>
              Our app lets you schedule a wash at a time and location that suits
              you. You can see the availability of washers in your area
              at-a-glance.
            </p>
          </div>
        </section>
        <h1>
          Get started by installing
          <br />
          our App today!
        </h1>

        <AppStoreLink />
      </article>
      <Footer />
    </div>
  );
};

export default withStyles(styles)(HomeScreen);



// WEBPACK FOOTER //
// ./src/screens/general/NewHomeScreen2.js